import { Badge, Card, Result, Select, Space } from 'antd'
// import NotifyCard from './Notify'

/*
 * @Author: Tina Huang
 * @Date: 2024-03-15 14:15:56
 * @LastEditors: Tina Huang
 * @LastEditTime: 2025-02-08 16:05:06
 * @Description:
 */
import { LIVE_TYPE } from '@/constants/lives'
import { Avatar, List, message, Image } from 'antd'
import { CaretRightFilled } from '@ant-design/icons'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { MessageInstance } from 'antd/es/message/interface'
import { ResultStatusType } from 'antd/es/result'
import Video from '@/assets/svgs/video'

const LivesMenu = (props: { type: string; list: LIVE_TYPE[]; messageApi: MessageInstance; onItemClick: (item: LIVE_TYPE) => void }) => {
  const { type, list, onItemClick } = props

  const handleLiveClick = useCallback(
    (item: LIVE_TYPE) => {
      onItemClick?.(item)
    },
    [onItemClick]
  )

  const handleLiveChange = (id: number) => {
    const item = list.find((item) => item.id === id)
    if (item) onItemClick?.(item)
  }

  const getItemStatus = (item: LIVE_TYPE, index: number) => {
    return {
      color: item?.child?.length || item?.link ? '#f56a00' : '#1677ff',
      _dom: item?.child?.length || item?.link ? <CaretRightFilled /> : index + 1,
    }
  }

  const renderOptions = () => {
    const _list = list.map((item, index) => {
      const status = getItemStatus(item, index)
      return { value: item.id, label: <Badge color={status?.color} text={item.title} /> }
    })
    return _list
  }

  const renderItem = (item: LIVE_TYPE, index: number) => {
    const status = getItemStatus(item, index)
    return (
      <List.Item className="cursor-pointer hover:text-blue-500" onClick={() => handleLiveClick(item)}>
        <List.Item.Meta
          className="hover:text-blue-500"
          avatar={<Avatar style={{ backgroundColor: status?.color }}>{status?._dom}</Avatar>}
          title={item.title}
          description={item?.time}
        />
      </List.Item>
    )
  }

  return (
    <>
      {type === 'normal' && (
        <Card style={{ width: 300, marginTop: 20 }} cover={<img alt="example" src="./assets/lives.png" />}>
          <List
            itemLayout="horizontal"
            pagination={{ position: 'bottom', align: 'center', pageSize: 5 }}
            dataSource={list}
            renderItem={renderItem}
          />
        </Card>
      )}
      {type === 'mobile' && <Select options={renderOptions()} defaultValue={5} className="w-full mb-4" onChange={handleLiveChange} />}
    </>
  )
}

export default function LivesList(props: { lists: any; originList: any }) {
  const { lists } = props
  const [messageApi, contextHolder] = message.useMessage()
  const isMobile = window.innerWidth <= 750
  const boxProps = isMobile ? 'pt-12 flex flex-col items-center' : 'pt-12 flex justify-between'
  const [activeItem, setActiveItem] = useState<LIVE_TYPE>()
  const [activeChild, setActiveChild] = useState<any>(null)

  const handleOpenItem = (item: LIVE_TYPE) => {
    setActiveItem(item)
  }
  const resultProps = useMemo(() => {
    if (activeItem?.done && (activeItem?.child?.length || activeItem?.link)) {
      // 进入播放
      return {
        status: 'success' as ResultStatusType,
        title: '该部分暂未开播',
        subTitle: '请尽情期待',
      }
    } else if (activeItem?.done) {
      // 待上传
      return {
        status: '500' as ResultStatusType,
        title: '该部分视频待上传',
        subTitle: '请尽情期待',
      }
    }
    // 待更新
    return {
      status: '500' as ResultStatusType,
      title: '该部分暂未开播',
      subTitle: '请尽情期待',
    }
  }, [activeItem])

  useEffect(() => {
    // if (isMobile) {
    const _activeItem = lists[1][4]
    setActiveItem(_activeItem)
    // setActiveChild(_activeItem.child[0])
    // }
  }, [lists])

  useEffect(() => {
    setActiveChild(activeItem?.child?.[0])
  }, [activeItem])

  const handleChildClick = (child: any) => {
    if (activeChild && activeChild?.title !== child.title) {
      setActiveChild(child)
    }
  }

  return (
    <div className={boxProps}>
      {contextHolder}
      {!isMobile && (
        <div className="w-1/4">
          {/* {lists[0].map((item: any) => (
          <NotifyCard />
        ))} */}
          {<LivesMenu type="normal" list={lists[1]} messageApi={messageApi} onItemClick={handleOpenItem} />}
        </div>
      )}
      {isMobile && <LivesMenu type="mobile" list={lists[1]} messageApi={messageApi} onItemClick={handleOpenItem} />}
      <div className={isMobile ? 'w-full' : 'w-3/4 pt-5'}>
        {!activeItem && (
          <>
            <h1 className="text-2xl font-bold">系列分享栏目</h1>
            <ul className="leading-10 text-lg mt-4">
              <li>1. 该栏目将整理发布直播回放内容</li>
              <li>2. 该栏目将更新教程内容</li>
              <li>3. 该栏目将更新Notion相关讯息</li>
            </ul>
          </>
        )}
        {activeItem && resultProps.status === '500' && <Result {...resultProps} />}
        {activeItem && resultProps.status === 'success' && (
          <>
            {activeItem?.link && (
              <>
                <h1 className="text-2xl font-bold">
                  {activeItem.title}{' '}
                  <a href={activeItem?.link} target="_blank" className="text-blue-500" rel="noreferrer">
                    {' '}
                    {'>>>'} 去看教程视频
                  </a>
                </h1>
                <Image src={activeItem?.cover} className="mt-4 rounded-lg" />
              </>
            )}
            {activeChild && (
              <>
                <h1 className="text-2xl font-bold">{activeChild?.title}</h1>
                <div className={`mt-4 bg-slate-300 rounded-lg ${isMobile ? 'h-60' : 'h-120'} flex items-center justify-center relative`}>
                  <h1 className="text-2xl text-slate-600">视频加载中...</h1>
                  <iframe
                    title="video"
                    className={`w-full ${isMobile ? 'h-full' : 'h-120'} absolute rounded-lg`}
                    src={activeChild?.url}
                    allowFullScreen={true}
                  />
                </div>
              </>
            )}
            <Space className="mt-4" wrap>
              {activeItem?.child?.map((child) => (
                <div
                  className={[
                    'flex items-center justify-center border border-solid p-2 rounded-lg cursor-pointer',
                    activeChild?.title === child.title ? 'bg-blue-500 text-white' : 'bg-white',
                  ].join(' ')}
                  onClick={() => handleChildClick(child)}
                >
                  <Video color={activeChild?.title === child.title ? 'white' : ''} />
                  <span className="ml-1">{child.title}</span>
                </div>
              ))}
            </Space>
          </>
        )}
      </div>
    </div>
  )
}
